import moment from 'moment';

// job.startTime carries the job-site wall-clock start in the job's own offset (the server builds
// it from the job's calendar day plus its start time-of-day). Read it with parseZone so it is not
// re-zoned to the browser, then re-create that wall clock in the browser's zone: react-big-calendar
// buckets by browser-local day, so every viewer sees the job on its own day at its own start time.
// Events carry a display-only 30-minute duration, clamped so a late start never spills into the
// next day's cell.
export const transformJobsToEvents = (jobs) => jobs.map((job) => {
    const start = moment(moment.parseZone(job.startTime).format('YYYY-MM-DDTHH:mm:ss'));

    return {
        id: job.id,
        title: `${job.jobNumber}: ${job.description}`,
        start: start.toDate(),
        end: moment.min(start.clone().add(30, 'minutes'), start.clone().endOf('day')).toDate(),
        resource: job,
        allDay: false,
    };
});
